import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase.js';

export interface UserProfile {
  email?: string;
  displayName?: string;
}

/** One-time (non-live) lookup of users/{uid} for a list of member uids — used to show an email
 * / display name next to a role in org and project member lists, which only store the uid. */
export function useUserProfiles(uids: string[]): Record<string, UserProfile> {
  const [profiles, setProfiles] = useState<Record<string, UserProfile>>({});
  const key = uids.join(',');

  useEffect(() => {
    let cancelled = false;
    void Promise.all(
      uids.map(async (uid) => {
        const snap = await getDoc(doc(db, 'users', uid));
        return [
          uid,
          snap.exists() ? { email: snap.data().email, displayName: snap.data().displayName } : {},
        ] as const;
      }),
    ).then((entries) => {
      if (!cancelled) setProfiles(Object.fromEntries(entries));
    });
    return () => {
      cancelled = true;
    };
    // `key` stands in for the uid list's real identity so this doesn't re-fetch on every render.
  }, [key]);

  return profiles;
}
